import React from 'react'

import * as Styled from './AverageFooter.styled'

type Props = {
  amount: number
  currency?: string
  isCurrency?: boolean
  marginLeft?: number
  hideDescriptionOnMobile: boolean
}

const AverageFooter: React.FC<Props> = ({
  amount,
  isCurrency,
  currency = 'EUR',
  marginLeft = 45,
  hideDescriptionOnMobile = true
}) => {
  const numberFormatProps = isCurrency
    ? {
        style: 'currency',
        currency
      }
    : {}
  const formattedAmount = new Intl.NumberFormat('ru-RU', {
    ...numberFormatProps,
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  }).format(amount)

  return (
    <Styled.Average marginLeft={marginLeft}>
      <Styled.Price>{formattedAmount}</Styled.Price>
      <Styled.Description hiddenOnMobile={hideDescriptionOnMobile}>
        &nbsp;средний показатель за период
      </Styled.Description>
    </Styled.Average>
  )
}

export default AverageFooter
